module.exports = __webpack_public_path__ + "img/issuance-cost-2.f42b6cd1.png";